import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import indexLogo from "../assets/images/index.svg";
import anytimeImg from "../assets/images/service1.png";
import feedbackImg from "../assets/images/service2.png";
import whoWatchedImg from "../assets/images/service3.png";
import messagesImg from "../assets/images/service4.png";
import hocLabImg from "../assets/images/hocLab.png";
import blendedImg from "../assets/images/blendedLearning.png";
import team1Img from "../assets/images/team1.jpg";
import team2Img from "../assets/images/team2.jpg";
import team3Img from "../assets/images/team3.jpg";
import team4Img from "../assets/images/team4.jpg";
import team5Img from "../assets/images/team5.jpg";
import team6Img from "../assets/images/team6.jpg";
import logoPolimi from "../assets/images/logoPolimi.png";
import evoliLogo from "../assets/images/evoli.png";
import { SButton } from "../components/BasicComponents";
import AppNavbar from "../components/Navbars/AppNavbar";
import Footer from "../components/Footer/Footer";

const IndexPage = () => {
  const { t } = useTranslation("", { keyPrefix: "landing" });
  const history = useHistory();

  const [showTopBtn, setShowTopBtn] = useState(false);
  /*   const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState(""); */

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });

    if (localStorage.getItem("user")) {
      const lastAccess = localStorage.getItem("lastAccess");
      history.push(lastAccess || "/student");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  return (
    <>
      <MainContainer fluid>
        <AppNavbar navLinks sticky="true" />
        <Hero>
          <Container>
            <Row>
              <Col lg={6} md={12} className="d-flex flex-column justify-content-center align-items-center pb-5">
                <img className="evoli-logo" src={evoliLogo} alt="EVOLI" />
                <h2 className="px-4 mt-0">{t("logo.slogan")}</h2>
                <div className="d-flex flex-row px-4">
                  <Link to="/login">
                    <SButton>{t("logo.login")}</SButton>
                  </Link>
                  <a href="#about" className="mx-2">
                    <SButton>{t("logo.get_started")}</SButton>
                  </a>
                </div>
              </Col>
              <Col lg={6} md={12} className="d-flex flex-column align-items-center pb-5">
                <img src={indexLogo} alt="Polimi" className="animated" />
              </Col>
            </Row>
          </Container>
        </Hero>

        <Strip fluid dark="true">
          <Container>
            <Row>
              <Col className="d-flex flex-column justify-content-center align-items-center">
                <h2 className="mt-5">{t("who.title")}</h2>
                <p>{t("who.description")}</p>
                <div className="d-flex flex-row justify-content-center align-items-center mb-5">
                  <img src={logoPolimi} alt="Polimi" className="mx-4" />
                  <img src={hocLabImg} alt="HOC lab" className="mx-4" />
                </div>
              </Col>
            </Row>
          </Container>
        </Strip>

        <About>
          <Container dark="true" id="about">
            <Row className="d-flex align-items-center">
              <Col lg={6} className="d-flex flex-column align-items-center">
                <img src={blendedImg} alt="Evoli logo" />
              </Col>
              <Col lg={6} className="pt-4 pt-lg-0 content">
                <SectionTitle>{t("strip.title")}</SectionTitle>
                <p>{t("strip.description1")}</p>
                <p>{t("strip.description2")}</p>
              </Col>
            </Row>
          </Container>
        </About>

        <Services>
          <Container id="services">
            <Row>
              <SectionTitle>{t("services.title")}</SectionTitle>
            </Row>
            <Row>
              <Col lg={6} className="service">
                <ServiceCard>
                  <img src={anytimeImg} alt="anytime" />
                  <h2>{t("services.service1.title")}</h2>
                  <p>{t("services.service1.description")}</p>
                </ServiceCard>
              </Col>
              <Col lg={6} className="service">
                <ServiceCard>
                  <img src={feedbackImg} alt="feedback" />
                  <h2>{t("services.service2.title")}</h2>
                  <p>{t("services.service2.description")}</p>
                </ServiceCard>
              </Col>
              <Col lg={6} className="service">
                <ServiceCard>
                  <img src={whoWatchedImg} alt="who watched" />
                  <h2>{t("services.service3.title")}</h2>
                  <p>{t("services.service3.description")}</p>
                </ServiceCard>
              </Col>
              <Col lg={6}>
                <ServiceCard className="service">
                  <img src={messagesImg} alt="messages and notes" />
                  <h2>{t("services.service4.title")}</h2>
                  <p>{t("services.service4.description")}</p>
                </ServiceCard>
              </Col>
            </Row>
          </Container>
        </Services>

        <Team>
          <Container id="team">
            <Row>
              <SectionTitle>{t("team.title")}</SectionTitle>
            </Row>
            <Row className="justify-content-lg-center">
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team1Img} alt="" />
                  <h4>{t("team.member1.name")}</h4>
                  <span>{t("team.member1.role")}</span>
                </TeamMember>
              </Col>
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team2Img} alt="" />
                  <h4>{t("team.member2.name")}</h4>
                  <span>{t("team.member2.role")}</span>
                </TeamMember>
              </Col>
            </Row>
            <Row>
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team3Img} alt="" />
                  <h4>{t("team.member3.name")}</h4>
                  <span>{t("team.member3.role")}</span>
                </TeamMember>
              </Col>
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team4Img} alt="" />
                  <h4>{t("team.member4.name")}</h4>
                  <span>{t("team.member4.role")}</span>
                </TeamMember>
              </Col>
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team5Img} alt="" />
                  <h4>{t("team.member5.name")}</h4>
                  <span>{t("team.member5.role")}</span>
                </TeamMember>
              </Col>
              <Col lg={3} sm={6}>
                <TeamMember>
                  <img src={team6Img} alt="" />
                  <h4>{t("team.member6.name")}</h4>
                  <span>{t("team.member6.role")}</span>
                </TeamMember>
              </Col>
            </Row>
          </Container>
        </Team>

        {/* <Contact>
          <Container id="contact">
            <Row>
              <SectionTitle>{t("contact.title")}</SectionTitle>
            </Row>
            <Row>
              <Container>
                <Form onSubmit={() => {}}>
                  <Row>
                    <Col lg={6} xs={12} className="d-flex flex-column justify-content-center align-items-center">
                      <SFormControl
                        className="fs-4 mt-4"
                        type="text"
                        placeholder={t("contact.name")}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                      <SFormControl
                        className="fs-4 mt-4"
                        type="email"
                        placeholder={t("contact.email")}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <SFormControl
                        className="fs-4 my-4"
                        type="text"
                        placeholder={t("contact.subject")}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </Col>
                    <Col lg={6} xs={12} className="d-flex flex-column flex-grow-1 justify-content-center">
                      <SFormControl
                        className="fs-4 my-4"
                        as="textarea"
                        placeholder={t("contact.message")}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <div className="d-flex flex-row justify-content-center">
                      <SButton type="submit" className="mt-4 mx-5 px-5 fs-5">
                        {t("contact.send")}
                      </SButton>
                    </div>
                  </Row>
                </Form>
              </Container>
            </Row>
          </Container>
        </Contact> */}
      </MainContainer>

      <Footer />

      {showTopBtn && (
        <BackToTop
          href="#"
          dark="true"
          className="d-flex align-items-center justify-content-center"
          onClick={scrollToTop}
        >
          <i className="fas fa-arrow-up" />
        </BackToTop>
      )}
    </>
  );
};

const MainContainer = styled(Container)`
  background-color: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-light)")};
  color: ${(props) => (props.dark ? "var(--text-primary-dark)" : "var(--text-primary-light)")} !important;
`;

const Hero = styled.section`
  display: flex;
  align-items: center;
  padding-top: 8rem;
  margin-bottom: 5rem;

  width: 100%;
  height: 80vh;

  .evoli-logo {
    height: 15vh;
    font-weight: 600;
  }

  h2 {
    font-size: 10vh;
    font-style: italic;
    font-weight: 100;
    text-align: center;
  }

  button {
    font-size: 1.5rem;
    width: 12rem;
  }

  .animated {
    animation: up-down 2s ease-in-out infinite alternate-reverse both;
  }

  @-webkit-keyframes up-down {
    0% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(-10px);
    }
  }

  @keyframes up-down {
    0% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(-10px);
    }
  }
`;

const Strip = styled(Container)`
  background-color: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-light)")};
  color: var(--text-primary-dark);
  margin-top: 7vh;
  margin-bottom: 10vh;

  h2 {
    text-transform: uppercase;
    font-weight: 700;
  }

  p {
    font-size: 1.2rem;
  }

  img {
    max-height: 5rem;
    max-width: 45%;
  }
`;

const SectionTitle = styled.h3`
  font-weight: 700;
  font-size: 2rem;
`;

const About = styled.section`
  margin-bottom: 10vh;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .content p {
    font-size: 1.2rem;
  }

  img {
    width: 80%;
  }
`;

const Services = styled.section`
  margin-bottom: 10vh;

  .service {
    margin: 10px 0 10px 0;
  }
`;

const ServiceCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: 28vh;
  padding: 3vh;
  margin: 0;

  background-color: var(--primary-dark);
  color: var(--text-primary-dark);

  img {
    height: 6vh;
  }

  h2 {
    font-size: 2rem;
  }
`;

const Team = styled.section`
  margin-bottom: 10vh;
`;

const TeamMember = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-bottom: 5vh;

  img {
    background-color: var(--primary-dark);
    height: 30vh;
    width: 30vh;
    border-radius: 50%;
  }

  h4 {
    margin: 1rem 0 0 0;
  }
`;

/* const Contact = styled.section`
  padding-bottom: 5vh;

  input {
    min-width: 32vw;
    margin: 0 auto 0 auto;
  }

  textarea {
    min-width: 40vw;
    height: 20rem;
    border-radius: 2em;
  }
`; */

const BackToTop = styled(SButton)`
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 10;

  border: 3px solid var(--primary-dark);
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
  transition: all 0.4s;

  i {
    font-size: 1.8rem;
  }
`;

export default IndexPage;
